import { Message, MessageBox } from 'element-ui';
export default {
  textRepl: function textRepl(str) {
    var reple = process.env.VUE_APP_IMAGEURLRPLE;
    var url = process.env.VUE_APP_IMAGEURL;
    var newstr = str.replaceAll(reple, url + reple);
    return newstr;
  },
  imgTrow: function imgTrow(str) {
    var isP = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var reple = process.env.VUE_APP_IMAGEURLRPLE;
    var url = process.env.VUE_APP_IMAGEURL;
    return isP ? url + str : str.replaceAll(reple, '');
  },
  copyText: function copyText(content, message) {
    var aux = document.createElement("input");
    aux.setAttribute("value", content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);

    if (message == null) {
      Message.success('复制成功');
    } else {
      Message.success(message);
    }
  }
};